export default [
  "WEBSITE_BUILDER_STARTER",
  "WEBSITE_BUILDER_PREMIUM",
  "WEBSITE_BUILDER_ECOMMERCE",
  "SITELOCK_LITE",
  "MARKETGOO_START",
  "UBERALL",
  "TERMLY",
  "WORDPRESS_MANAGED",
  "DNS_ADMIN",
  "MAIL_STORAGE_UNLIMITED",
  "EXCHANGE_ONLINE",
  "EXCHANGE_M365_BUSINESS_BASIC",
  "EXCHANGE_M365_BUSINESS_STANDARD",
  "ONEVPS_PLESK_ADMIN_LICENSE",
  "ONEVPS_PLESK_PRO_LICENSE",
  "ONEVPS_PLESK_HOST_LICENSE",
  "ONEVPS_BASIC_BACKUP",
  "RANK_MATH",
  "PREMIUM_WORDPRESS_CARE",
  "SITELOCK_FIX",
  "BOOKINGS",
];
